/**
 * Koda quick-action labels and send texts for Research finder cards.
 * Mirrors student KodaBlockCard prompts; sendText is what Koda receives.
 */

export function buildCareerKodaActions({ career, country, isSelectedCountry }) {
	if (!career) return []

	const countrySuffix =
		country && isSelectedCountry ? ` in ${country}` : ''

	return [
		{
			id: 'countries',
			label: `🌍 Find the best countries for a ${career}?`,
			sendText: `Which countries offer the best opportunities for a career in ${career}?`,
		},
		{
			id: 'courses',
			label: `📚 Which courses lead to a ${career} career?`,
			sendText: `What are the best courses to study to become a ${career}${countrySuffix}?`,
		},
		{
			id: 'universities',
			label: `🎓 Discover top universities for ${career} studies?`,
			sendText: `What are the top universities${countrySuffix} for someone pursuing a ${career} career?`,
		},
		{
			id: 'ask',
			label: `💬 Ask Koda AI about ${career}?`,
			sendText: `I have questions about careers in ${career}`,
		},
	]
}

export function buildCountryKodaActions({ career, country }) {
	if (!country || !career) return []

	return [
		{
			id: 'courses',
			label: `📚 Courses in ${country} for a ${career}?`,
			sendText: `Which courses in ${country} are suitable for a career in ${career}?`,
		},
		{
			id: 'universities',
			label: `🎓 Top unis in ${country} for ${career}?`,
			sendText: `What are the top universities in ${country} for a ${career} career?`,
		},
		{
			id: 'similar',
			label: `🤔 Similar careers to ${career} in ${country}?`,
			sendText: `What are similar career paths to ${career} in ${country}?`,
		},
		{
			id: 'ask',
			label: `💬 Ask Koda AI about careers in ${country}`,
			sendText: `I have some questions about a career as a ${career} in ${country}`,
		},
	]
}

export function buildCourseKodaActions({ course, country, isSelectedCountry }) {
	if (!course) return []

	const countrySuffix =
		country && isSelectedCountry ? ` in ${country}` : ''

	return [
		{
			id: 'careers',
			label: `💼 What careers can a ${course} degree lead to?`,
			sendText: `What career opportunities are available for someone with a degree in ${course}${countrySuffix}?`,
		},
		{
			id: 'countries',
			label: `🌍 Discover top countries to study ${course}?`,
			sendText: `Which countries are best for studying ${course}?`,
		},
		{
			id: 'universities',
			label: `🎓 See top universities offering ${course}${countrySuffix}?`,
			sendText: `What are the top universities that offer ${course} programs${countrySuffix}?`,
		},
		{
			id: 'ask',
			label: `💬 Ask Koda AI about ${course}`,
			sendText: `I want to ask questions about ${course}. What would I study in this program?`,
		},
	]
}

export function buildResearchKodaActions(type, context = {}) {
	switch (type) {
		case 'career':
			return buildCareerKodaActions(context)
		case 'country':
			return buildCountryKodaActions(context)
		case 'course':
			return buildCourseKodaActions(context)
		default:
			return []
	}
}

export function buildResearchKodaTitle(type, context = {}) {
	switch (type) {
		case 'career':
			return context.career ? `${context.career} related questions` : 'Career related questions'
		case 'country':
			return context.country
				? `${context.country} related questions`
				: 'Country related questions'
		case 'course':
			return context.course ? `${context.course} related questions` : 'Course related questions'
		default:
			return 'Related questions'
	}
}
